import { useLanguage } from '../contexts/LanguageContext';

// Translation mappings for dynamic content
const TRANSLATION_MAPPINGS = {
  // Categories
  categories: {
    'Vozila': {
      en: 'Vehicles',
      fr: 'Véhicules', 
      es: 'Vehículos',
      it: 'Veicoli',
      ru: 'Транспорт',
      ar: 'مركبات',
      de: 'Fahrzeuge'
    },
    'Kompjuteri': {
      en: 'Computers',
      fr: 'Ordinateurs',
      es: 'Computadoras', 
      it: 'Computer',
      ru: 'Компьютеры',
      ar: 'حاسوب',
      de: 'Computer'
    },
    'Mobilni uređaji': {
      en: 'Mobile Devices',
      fr: 'Appareils Mobiles',
      es: 'Dispositivos Móviles',
      it: 'Dispositivi Mobili', 
      ru: 'Мобильные устройства',
      ar: 'الأجهزة المحمولة',
      de: 'Mobile Geräte'
    },
    'Tehnika': {
      en: 'Technology',
      fr: 'Technologie',
      es: 'Tecnología',
      it: 'Tecnologia',
      ru: 'Технология', 
      ar: 'تقنية',
      de: 'Technologie'
    },
    'Moj dom': {
      en: 'My Home',
      fr: 'Ma Maison',
      es: 'Mi Hogar',
      it: 'La Mia Casa',
      ru: 'Мой дом',
      ar: 'منزلي', 
      de: 'Mein Zuhause'
    },
    'Ljepota i zdravlje': {
      en: 'Beauty & Health',
      fr: 'Beauté et Santé',
      es: 'Belleza y Salud',
      it: 'Bellezza e Salute',
      ru: 'Красота и здоровье',
      ar: 'الجمال والصحة',
      de: 'Schönheit & Gesundheit'
    }
  },

  // Product conditions
  conditions: {
    'Novo': {
      en: 'New',
      fr: 'Nouveau',
      es: 'Nuevo',
      it: 'Nuovo',
      ru: 'Новый',
      ar: 'جديد',
      de: 'Neu'
    },
    'Polovno': {
      en: 'Used',
      fr: 'Utilisé',
      es: 'Usado',
      it: 'Usato',
      ru: 'Б/у',
      ar: 'مستعمل',
      de: 'Gebraucht'
    },
    'Oštećeno': {
      en: 'Damaged',
      fr: 'Endommagé',
      es: 'Dañado',
      it: 'Danneggiato',
      ru: 'Поврежденный',
      ar: 'تالف',
      de: 'Beschädigt'
    }
  },

  // Locations/Regions
  locations: {
    'Banjalučka': {
      en: 'Banja Luka Region',
      fr: 'Région de Banja Luka',
      es: 'Región de Banja Luka',
      it: 'Regione di Banja Luka',
      ru: 'Регион Баня-Лука',
      ar: 'منطقة بانيا لوكا',
      de: 'Region Banja Luka'
    },
    'Sarajevo': {
      en: 'Sarajevo',
      fr: 'Sarajevo',
      es: 'Sarajevo',
      it: 'Sarajevo',
      ru: 'Сараево',
      ar: 'سراييفو',
      de: 'Sarajevo'
    },
    // Add more locations as needed
  },

  // Common UI elements
  ui: {
    'Promovisano': {
      en: 'Promoted',
      fr: 'Promu',
      es: 'Promocionado',
      it: 'Promosso',
      ru: 'Продвигается',
      ar: 'مروج',
      de: 'Beworben'
    },
    'Nepoznato': {
      en: 'Unknown',
      fr: 'Inconnu',
      es: 'Desconocido',
      it: 'Sconosciuto',
      ru: 'Неизвестно',
      ar: 'غير معروف',
      de: 'Unbekannt'
    },
    'Nema rezultata': {
      en: 'No results',
      fr: 'Aucun résultat',
      es: 'Sin resultados',
      it: 'Nessun risultato',
      ru: 'Нет результатов',
      ar: 'لا توجد نتائج',
      de: 'Keine Ergebnisse'
    },
    'Učitaj još': {
      en: 'Load more',
      fr: 'Charger plus',
      es: 'Cargar más',
      it: 'Carica altro',
      ru: 'Загрузить еще',
      ar: 'تحميل المزيد',
      de: 'Mehr laden'
    },
    'Nema pronadjenih proizvoda': {
      en: 'No products found',
      fr: 'Aucun produit trouvé',
      es: 'No se encontraron productos',
      it: 'Nessun prodotto trovato',
      ru: 'Товары не найдены',
      ar: 'لم يتم العثور على منتجات',
      de: 'Keine Produkte gefunden',
      pt: 'Nenhum produto encontrado',
      tr: 'Ürün bulunamadı',
      zh: '未找到产品'
    },
    'Pretraživanje': {
      en: 'Searching',
      fr: 'Recherche',
      es: 'Búsqueda',
      it: 'Ricerca',
      ru: 'Поиск',
      ar: 'البحث',
      de: 'Suche',
      pt: 'Pesquisa',
      tr: 'Arama',
      zh: '搜索'
    },
    'Povezane pretrage': {
      en: 'Related searches',
      fr: 'Recherches associées',
      es: 'Búsquedas relacionadas',
      it: 'Ricerche correlate',
      ru: 'Связанные поиски',
      ar: 'عمليات بحث ذات صلة',
      de: 'Verwandte Suchen',
      pt: 'Pesquisas relacionadas',
      tr: 'İlgili aramalar',
      zh: '相关搜索'
    },
    'Kategorije za nastavak pretrage': {
      en: 'Categories to continue searching',
      fr: 'Catégories pour continuer la recherche',
      es: 'Categorías para continuar la búsqueda',
      it: 'Categorie per continuare la ricerca',
      ru: 'Категории для продолжения поиска',
      ar: 'فئات لمتابعة البحث',
      de: 'Kategorien zum Weitersuchen',
      pt: 'Categorias para continuar a pesquisa',
      tr: 'Aramaya devam etmek için kategoriler',
      zh: '继续搜索的类别'
    },
    'Povezane kategorije': {
      en: 'Related categories',
      fr: 'Catégories associées',
      es: 'Categorías relacionadas',
      it: 'Categorie correlate',
      ru: 'Связанные категории',
      ar: 'فئات ذات صلة',
      de: 'Verwandte Kategorien',
      pt: 'Categorias relacionadas',
      tr: 'İlgili kategoriler',
      zh: '相关类别'
    },
    'Pokušajte drugačiju pretragu': {
      en: 'Try a different search',
      fr: 'Essayez une autre recherche',
      es: 'Pruebe una búsqueda diferente',
      it: 'Prova una ricerca diversa',
      ru: 'Попробуйте другой поиск',
      ar: 'جرب بحثًا مختلفًا',
      de: 'Versuchen Sie eine andere Suche',
      pt: 'Tente uma pesquisa diferente',
      tr: 'Farklı bir arama deneyin',
      zh: '尝试其他搜索'
    },
    'Popularne kategorije': {
      en: 'Popular categories',
      fr: 'Catégories populaires',
      es: 'Categorías populares',
      it: 'Categorie popolari',
      ru: 'Популярные категории',
      ar: 'الفئات الشائعة',
      de: 'Beliebte Kategorien',
      pt: 'Categorias populares',
      tr: 'Popüler kategoriler',
      zh: '热门类别'
    },
    'Najnoviji oglasi': {
      en: 'Latest listings',
      fr: 'Dernières annonces',
      es: 'Anuncios más recientes',
      it: 'Annunci più recenti',
      ru: 'Новые объявления',
      ar: 'أحدث الإعلانات',
      de: 'Neueste Anzeigen',
      pt: 'Anúncios mais recentes',
      tr: 'En yeni ilanlar',
      zh: '最新广告'
    },
    'Slični oglasi': {
      en: 'Similar listings',
      fr: 'Annonces similaires',
      es: 'Anuncios similares',
      it: 'Annunci simili',
      ru: 'Похожие объявления',
      ar: 'إعلانات مشابهة',
      de: 'Ähnliche Anzeigen',
      pt: 'Anúncios semelhantes',
      tr: 'Benzer ilanlar',
      zh: '类似广告'
    },
    'Slični proizvodi': {
      en: 'Similar products',
      fr: 'Produits similaires',
      es: 'Productos similares',
      it: 'Prodotti simili',
      ru: 'Похожие товары',
      ar: 'منتجات مشابهة',
      de: 'Ähnliche Produkte',
      pt: 'Produtos semelhantes',
      tr: 'Benzer ürünler',
      zh: '类似产品'
    },
    'Popularno u ovoj kategoriji': {
      en: 'Popular in this category',
      fr: 'Populaire dans cette catégorie',
      es: 'Popular en esta categoría',
      it: 'Popolare in questa categoria',
      ru: 'Популярное в этой категории',
      ar: 'شائع في هذه الفئة',
      de: 'Beliebt in dieser Kategorie',
      pt: 'Popular nesta categoria',
      tr: 'Bu kategoride popüler',
      zh: '此类别热门'
    },
    'Slični oglasi iz šire kategorije': {
      en: 'Similar listings from the broader category',
      fr: 'Annonces similaires de la catégorie élargie',
      es: 'Anuncios similares de la categoría más amplia',
      it: 'Annunci simili dalla categoria più ampia',
      ru: 'Похожие объявления из более широкой категории',
      ar: 'إعلانات مشابهة من الفئة الأوسع',
      de: 'Ähnliche Anzeigen aus der übergeordneten Kategorie',
      pt: 'Anúncios semelhantes da categoria mais ampla',
      tr: 'Daha geniş kategoriden benzer ilanlar',
      zh: '更广类别中的类似广告'
    },
    'Pretraga za': {
      en: 'Search for',
      fr: 'Recherche pour',
      es: 'Búsqueda de',
      it: 'Ricerca per',
      ru: 'Поиск по запросу',
      ar: 'بحث عن',
      de: 'Suche nach',
      pt: 'Pesquisa por',
      tr: 'Şunun için arama',
      zh: '搜索'
    },
    'Pošalji Novu Poruku': {
      en: 'Send New Message',
      fr: 'Envoyer un nouveau message',
      es: 'Enviar nuevo mensaje',
      it: 'Invia nuovo messaggio',
      ru: 'Отправить новое сообщение',
      ar: 'إرسال رسالة جديدة',
      de: 'Neue Nachricht senden',
      pt: 'Enviar nova mensagem',
      tr: 'Yeni Mesaj Gönder',
      zh: '发送新消息'
    },
    'Brzi odgovor na': {
      en: 'Fast reply at',
      fr: 'Réponse rapide au',
      es: 'Respuesta rápida al',
      it: 'Risposta rapida al',
      ru: 'Быстрый ответ по',
      ar: 'رد سريع على',
      de: 'Schnelle Antwort unter',
      pt: 'Resposta rápida em',
      tr: 'Hızlı yanıt',
      zh: '快速回复'
    },
    'Kategorija': {
      en: 'Category',
      fr: 'Catégorie',
      es: 'Categoría',
      it: 'Categoria',
      ru: 'Категория',
      ar: 'الفئة',
      de: 'Kategorie',
      pt: 'Categoria',
      tr: 'Kategori',
      zh: '类别'
    },
    'Još oglasa od ovog prodavca': {
      en: 'More listings from this seller',
      fr: 'Plus d’annonces de ce vendeur',
      es: 'Más anuncios de este vendedor',
      it: 'Altri annunci di questo venditore',
      ru: 'Другие объявления этого продавца',
      ar: 'إعلانات أخرى من هذا البائع',
      de: 'Weitere Anzeigen dieses Verkäufers',
      pt: 'Mais anúncios deste vendedor',
      tr: 'Bu satıcıdan daha fazla ilan',
      zh: '该卖家的更多广告'
    },
    'Prikaži sve filtere': {
      en: 'Show all filters',
      fr: 'Afficher tous les filtres',
      es: 'Mostrar todos los filtros',
      it: 'Mostra tutti i filtri',
      ru: 'Показать все фильтры',
      ar: 'عرض كل الفلاتر',
      de: 'Alle Filter anzeigen',
      pt: 'Mostrar todos os filtros',
      tr: 'Tüm filtreleri göster',
      zh: '显示所有筛选器'
    },
    'Sakrij sve filtere': {
      en: 'Hide all filters',
      fr: 'Masquer tous les filtres',
      es: 'Ocultar todos los filtros',
      it: 'Nascondi tutti i filtri',
      ru: 'Скрыть все фильтры',
      ar: 'إخفاء كل الفلاتر',
      de: 'Alle Filter ausblenden',
      pt: 'Ocultar todos os filtros',
      tr: 'Tüm filtreleri gizle',
      zh: '隐藏所有筛选器'
    },
    'Resetuj': {
      en: 'Reset',
      fr: 'Réinitialiser',
      es: 'Restablecer',
      it: 'Reimposta',
      ru: 'Сбросить',
      ar: 'إعادة تعيين',
      de: 'Zurücksetzen',
      pt: 'Redefinir',
      tr: 'Sıfırla',
      zh: '重置'
    },
    'Filteri za cijenu, stanje, preuzimanje i dodatne karakteristike': {
      en: 'Filters for price, condition, pickup and additional features',
      fr: 'Filtres pour le prix, l’état, la remise et les caractéristiques supplémentaires',
      es: 'Filtros de precio, estado, recogida y características adicionales',
      it: 'Filtri per prezzo, condizione, ritiro e caratteristiche aggiuntive',
      ru: 'Фильтры по цене, состоянию, получению и дополнительным характеристикам',
      ar: 'فلاتر السعر والحالة والاستلام والميزات الإضافية',
      de: 'Filter für Preis, Zustand, Abholung und zusätzliche Merkmale',
      pt: 'Filtros por preço, condição, retirada e características adicionais',
      tr: 'Fiyat, durum, teslim alma ve ek özellikler için filtreler',
      zh: '价格、状态、取货和其他特征筛选器'
    },
    'Pregledajte oglase, cijene, lokacije i prodavce za unesenu pretragu.': {
      en: 'Browse listings, prices, locations and sellers for the entered search.',
      fr: 'Parcourez les annonces, prix, lieux et vendeurs pour la recherche saisie.',
      es: 'Revise anuncios, precios, ubicaciones y vendedores para la búsqueda ingresada.',
      it: 'Consulta annunci, prezzi, località e venditori per la ricerca inserita.',
      ru: 'Просмотрите объявления, цены, местоположения и продавцов по введенному запросу.',
      ar: 'تصفح الإعلانات والأسعار والمواقع والبائعين لعبارة البحث المدخلة.',
      de: 'Durchsuchen Sie Anzeigen, Preise, Standorte und Verkäufer für die eingegebene Suche.',
      pt: 'Veja anúncios, preços, locais e vendedores para a pesquisa inserida.',
      tr: 'Girilen arama için ilanları, fiyatları, konumları ve satıcıları inceleyin.',
      zh: '浏览输入搜索的广告、价格、位置和卖家。'
    },
    'Dodajte novi proizvod': {
      en: 'Add new product',
      fr: 'Ajouter un nouveau produit',
      es: 'Agregar nuevo producto',
      it: 'Aggiungi nuovo prodotto',
      ru: 'Добавить новый товар',
      ar: 'إضافة منتج جديد',
      de: 'Neues Produkt hinzufügen'
    },
    'Popularne Radnje': {
      en: 'Popular Shops',
      fr: 'Boutiques Populaires',
      es: 'Tiendas Populares',
      it: 'Negozi Popolari',
      ru: 'Популярные магазины',
      ar: 'المتاجر الشعبية',
      de: 'Beliebte Geschäfte'
    }
  }
};

/**
 * Translates a single text value based on current language
 * @param {string} text - Original text to translate
 * @param {string} category - Category of translation (categories, conditions, etc.)
 * @param {string} currentLanguage - Current language code
 * @returns {string} Translated text or original if no translation found
 */
export const translateText = (text, category, currentLanguage = 'ba') => {
  if (!text || !category || !TRANSLATION_MAPPINGS[category]) {
    return text;
  }

  const translations = TRANSLATION_MAPPINGS[category][text];
  if (translations && translations[currentLanguage]) {
    return translations[currentLanguage];
  }

  return text; // Return original if no translation found
};

/**
 * Translates an object's properties based on translation mappings
 * @param {Object} obj - Object to translate
 * @param {Object} fieldMappings - Mapping of field names to translation categories
 * @param {string} currentLanguage - Current language code
 * @returns {Object} Translated object
 */
export const translateObject = (obj, fieldMappings, currentLanguage = 'ba') => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const translatedObj = { ...obj };

  Object.keys(fieldMappings).forEach(field => {
    if (translatedObj[field]) {
      const category = fieldMappings[field];
      translatedObj[field] = translateText(translatedObj[field], category, currentLanguage);
    }
  });

  return translatedObj;
};

/**
 * Translates an array of objects
 * @param {Array} array - Array of objects to translate
 * @param {Object} fieldMappings - Mapping of field names to translation categories
 * @param {string} currentLanguage - Current language code
 * @returns {Array} Array of translated objects
 */
export const translateArray = (array, fieldMappings, currentLanguage = 'ba') => {
  if (!Array.isArray(array)) {
    return array;
  }

  return array.map(item => translateObject(item, fieldMappings, currentLanguage));
};

/**
 * Translates product data specifically
 * @param {Object|Array} data - Product data to translate
 * @param {string} currentLanguage - Current language code
 * @returns {Object|Array} Translated product data
 */
export const translateProductData = (data, currentLanguage = 'ba') => {
  const productFieldMappings = {
    category: 'categories',
    condition: 'conditions',
    location: 'locations'
  };

  if (Array.isArray(data)) {
    return translateArray(data, productFieldMappings, currentLanguage);
  }

  return translateObject(data, productFieldMappings, currentLanguage);
};

/**
 * Translates category data specifically
 * @param {Object|Array} data - Category data to translate
 * @param {string} currentLanguage - Current language code
 * @returns {Object|Array} Translated category data
 */
export const translateCategoryData = (data, currentLanguage = 'ba') => {
  const categoryFieldMappings = {
    name: 'categories',
    title: 'categories'
  };

  if (Array.isArray(data)) {
    return translateArray(data, categoryFieldMappings, currentLanguage);
  }

  return translateObject(data, categoryFieldMappings, currentLanguage);
};

/**
 * Translates UI text elements
 * @param {string} text - UI text to translate
 * @param {string} currentLanguage - Current language code
 * @returns {string} Translated UI text
 */
export const translateUI = (text, currentLanguage = 'ba') => {
  return translateText(text, 'ui', currentLanguage);
};

/**
 * Hook for using translation functions with current language context
 * @returns {Object} Translation functions with current language applied
 */
export const useDataTranslation = () => {
  const { currentLanguage } = useLanguage();

  return {
    translateText: (text, category) => translateText(text, category, currentLanguage),
    translateObject: (obj, fieldMappings) => translateObject(obj, fieldMappings, currentLanguage),
    translateArray: (array, fieldMappings) => translateArray(array, fieldMappings, currentLanguage),
    translateProductData: (data) => translateProductData(data, currentLanguage),
    translateCategoryData: (data) => translateCategoryData(data, currentLanguage),
    translateUI: (text) => translateUI(text, currentLanguage),
    currentLanguage
  };
};

/**
 * Adds language parameter to API URLs
 * @param {string} url - Base API URL
 * @param {string} currentLanguage - Current language code
 * @returns {string} URL with language parameter
 */
export const addLanguageToAPI = (url, currentLanguage = 'ba') => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}lang=${currentLanguage}`;
};

export default {
  translateText,
  translateObject,
  translateArray,
  translateProductData,
  translateCategoryData,
  translateUI,
  useDataTranslation,
  addLanguageToAPI,
  TRANSLATION_MAPPINGS
};
